/**
 * Admin API endpoints (superuser only)
 */
import { apiClient } from '../client'
import { Organization } from './organizations'
import { User } from './users'

export interface SystemStats {
  total_users: number
  active_users: number
  total_projects: number
  total_tasks: number
}

export const adminApi = {
  /**
   * List all users across all organizations (admin only)
   */
  async listAllUsers(params?: {
    skip?: number
    limit?: number
  }): Promise<User[]> {
    const response = await apiClient.get<User[]>('/api/v1/admin/users', { params })
    return response.data
  },

  /**
   * List all organizations (admin only)
   */
  async listAllOrganizations(params?: {
    skip?: number
    limit?: number
    include_deleted?: boolean
  }): Promise<Organization[]> {
    const response = await apiClient.get<Organization[]>('/api/v1/admin/organizations', { params })
    return response.data
  },

  /**
   * Get system-wide statistics (admin only)
   */
  async getSystemStats(): Promise<SystemStats> {
    const response = await apiClient.get<SystemStats>('/api/v1/admin/stats')
    return response.data
  },
}

